import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const usePageTracking = () => {
  type trackingCodeType = '' | 'G-ZF9ZDEVLFR';

  const location = useLocation();

  let trackingCode: trackingCodeType = 'G-ZF9ZDEVLFR';

  useEffect(() => {
    ReactGA.initialize(trackingCode);
    ReactGA.send('pageview');
  }, [location, trackingCode]);
};

export default usePageTracking;
